export default __webpack_public_path__ + "static/media/tete28.1e18ef94.png";